import type GeoType from '@/Enums/Geography/GeographyType.enum';
import type { ILocation } from '@/Interfaces/Forecaster';
import { GEO_TARGETING_LOCATIONS_LOOKUP, GEO_TARGETING_SEARCH } from '@/constants/endpoints';
import axios from 'axios';

export type FetchTargetingLocationsParams = {
  search: string;
  limit?: number;
  excludeTypes?: GeoType[];
};

export const fetchTargetingLocations = async (params: FetchTargetingLocationsParams) => {
  // Endpoint is not intended to fetch all the locations
  if (!params.search.length) {
    return [];
  }

  const { data } = await axios.get<ILocation[]>(GEO_TARGETING_SEARCH, {
    params: {
      ...params,
      limit: params.limit || 100,
    },
  });
  return data;
};

export const fetchTargetingLocationsLookup = async ({ zips, states }: { zips?: string[]; states?: string[] }) => {
  if (!zips?.length && !states?.length) {
    return { found: [], notFound: [] };
  }

  const { data } = await axios.post<{ found: ILocation[]; notFound: ILocation[] }>(GEO_TARGETING_LOCATIONS_LOOKUP, {
    zips,
    states,
  });
  return data;
};
